export default {"src":"/_next/static/media/our-dna-icon.f797e599.svg","height":138,"width":138,"blurWidth":0,"blurHeight":0};